<template>

<div class="widget-item">
    <div class="widget-item-body">
        
        <div class="widget-item-text">

        <p class="widget-item-description" v-if="widget.description">{{widget.description}}</p>

        <p class="mb-3" v-if="baseline">
            The pre-operative value is <b>{{labels[input]}}</b>
        </p>
        
        <p class="mb-3" v-else>
            Please choose an associated input for '{{widget.title}}'.
        </p>

        <p class="mb-3" v-if="baseline">
            The frequency of ...
        </p>

        <div v-if="baseline">
            <p v-for="(prob, index) in output" :key="index">
                <span v-if="input===index">
                    <b>No change</b> is <b>{{getFrequency(prob)}}</b> out of 100
                </span>
                <span v-else>
                    <b>{{baseline}}</b> to <b>{{labels[index]}}</b> is <b>{{getFrequency(prob)}}</b> out of 100
                </span>
            </p>
        </div>

    </div>

    <div class="widget-item-chart">
    
        <canvas :id="`chart_${widget.id}`" />

    </div>

    </div>

</div>
</template>

<script>

import { parseData, initChart } from '@/components/charts/StateChange.js'
import { getFrequency } from '@/assets/js/functions'

export default {
    name: 'StateChangeWidget',
    props: {
        widget: Object
    },
    data(){
        return {
            chart: null
        }
    },
    computed: {
        variables(){
            return this.widget.variables
        },
        variableIds() {
            return this.variables.map(variable => variable.id)
        },
        labels() {
            return this.widget.parameters.alt_states ? this.widget.parameters.alt_states : this.variables[0].states
        },
        outputData(){
            return this.$store.getters['getOutputs'](this.variables)
        },
        input() {
            return this.outputData[0] ? this.outputData[0].indexOf(1) : null
        },
        output() {
            return this.outputData[1]
        },
        baseline(){            
            return this.input === null ? null : this.labels[this.input]
        }
    },
    watch: {
        outputData(newData){
            
            const { baseline_val, parsed_data } = parseData(newData)

            this.chart.data.baseline = (baseline_val !== null) ? this.labels[baseline_val] : null
            this.chart.data.datasets[0].data = parsed_data
            this.chart.update()
        }
    },
    mounted(){
        const ctx = document.getElementById(`chart_${this.widget.id}`)
        this.chart = initChart(ctx, this.labels, this.outputData, this.widget.parameters)
    },
    methods: {
        getFrequency
    }
}

</script>